<template>
    <v-row class="mt-4">
        <v-col>
            <v-data-table class="search-tab-table mt-4"
                          :headers="connectedUsersHeaders"
                          :items="connectedUsers"

                          :items-per-page="-1"

                          :loading="informationProgressBar"
                          :loading-text="$gettext('Just a moment, loading the connected users.')"
                          multi-sort
            >
                <template v-slot:header.ip="{ header }">
                    <v-icon small class="mr-2" v-text="icons.mdiNumeric" v-once></v-icon>
                    <span class="font-weight-bold" v-text="header.text"></span>
                </template>
                <template v-slot:header.mac="{ header }">
                    <v-icon small class="mr-2" v-text="icons.mdiLaptop" v-once></v-icon>
                    <span class="font-weight-bold" v-text="header.text"></span>
                </template>
                <template v-slot:header.active="{ header }">
                    <v-icon small class="mr-2" v-text="icons.mdiToggleSwitchOutline" v-once></v-icon>
                    <span class="font-weight-bold" v-text="header.text"></span>
                </template>
                <template v-slot:header.hostname="{ header }">
                    <v-icon small class="mr-2" v-text="icons.mdiFormTextbox" v-once></v-icon>
                    <span class="font-weight-bold" v-text="header.text"></span>
                </template>
                <template v-slot:header.name="{ header }">
                    <v-icon small class="mr-2" v-text="icons.mdiAccount" v-once></v-icon>
                    <span class="font-weight-bold" v-text="header.text"></span>
                </template>


                <template v-slot:item.ip="{ item }">
                    <span v-text="item.ip"></span>
                </template>
                <template v-slot:item.active="{ item }">
                    <v-chip v-if="item.active" rounded small :color="item.color" class="white--text elevation-1">
                        <!--                        <v-badge-->
                        <!--                            bordered-->
                        <!--                            inline-->
                        <!--                            dot-->
                        <!--                            :color="item.color"-->
                        <!--                            class="ml-0"-->
                        <!--                        >-->
                        <!--                        </v-badge>-->
                        {{ item.active }}
                    </v-chip>
                    <span v-else> </span>
                </template>
                <template v-slot:item.mac="{ item }">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on, attrs }">
                            <a @click="openInformationConnectedUsersAddEquipmentDialog(item.mac)" v-text="item.mac" v-bind="attrs" v-on="on"></a>
                        </template>
                        <span v-text="$gettext('Tap to add as an equipment')"></span>
                    </v-tooltip>
                </template>
                <template v-slot:item.hostname="{ item }">
                    <span v-text="removeDoubleQuotes(item.hostname)"></span>
                </template>
                <template v-slot:item.actions="{ item }" class="text-right">
                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" class="ml-auto d-flex">
                                <v-icon v-text="$vuetify.breakpoint.mdAndUp ? icons.mdiDotsVertical : icons.mdiDotsHorizontal"></v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item class="cursor-pointer" @click="openInformationConnectedUsersAddEquipmentDialog(item.mac)">
                                <v-list-item-title>
                                    <v-btn icon class="mr-1">
                                        <v-icon v-text="icons.mdiPlus" color="secondary"></v-icon>
                                    </v-btn>
                                    {{ $gettext('Add Equipment') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-data-table>
        </v-col>
        <dialog-information-connected-users-add-equipment
            v-if="informationConnectedUsersAddEquipmentDialog"
            :params="informationConnectedUsersAddEquipmentParams"></dialog-information-connected-users-add-equipment>
        <snackbar ref="snackbar"></snackbar>
    </v-row>
</template>
<script>

import MixinConfigInformation from '../../../mixins/database/MixinConfigInformation'
import { mapState, mapWritableState } from 'pinia'
import MixinIcon from '@/mixins/MixinIcon'
import DialogInformationConnectedUsersAddEquipment from '@/components/dialogs/informations_tab/DialogInformationConnectedUsersAddEquipment.vue'
import MixinDialog from '@/mixins/MixinDialog'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import Snackbar from '@/components/Snackbar.vue'
import { useUsersStore } from '@/stores/UsersStore'
import { useInformationStore } from '@/stores/InformationStore'

export default {
    name: 'ConnectedUsers',
    props: {
        params: {
            required: true
        },
    },
    components: { Snackbar, DialogInformationConnectedUsersAddEquipment },
    mixins: [MixinConfigInformation, MixinIcon, MixinDialog, MixinVuelidate],
    data () {
        return {

            informationConnectedUsersAddEquipmentDialog: false,
            informationConnectedUsersAddEquipmentParams: '',

            connectedUsersHeaders: [
                {
                    text: this.$gettext('IP'),
                    value: 'ip',
                    sortable: true,
                    filter: this.connectedUsersGeneralFilter
                },
                {
                    text: this.$gettext('Mac'),
                    value: 'mac',
                    sortable: true,
                    filter: this.connectedUsersMacFilter,
                },
                /*{
                    text: 'Status',
                    value: 'status',
                    sortable: true,
                },*/
                {
                    text: this.$gettext('Status'),
                    value: 'active',
                    sortable: true,
                    filter: this.connectedUsersStatusFilter
                },
                {
                    text: this.$gettext('Hostname'),
                    value: 'hostname',
                    sortable: true,
                },
                {
                    text: this.$gettext('Name'),
                    value: 'name',
                    sortable: true,
                },
                {
                    text: this.$vuetify.breakpoint.smAndDown ? this.$gettext('Actions') : '',
                    value: 'actions',
                    sortable: false
                }
            ],
        }
    },

    mounted () {

    },

    computed: {

        ...mapState(useInformationStore, {
            connectedUsers: 'connectedUsers',
        }),
        ...mapState(useUsersStore, {
            users: 'users'
        })

    },

    methods: {

        connectedUsersStatusFilter (value) {

            let self = this

            if (self.$props.params.connectedUsersStatusFilterValue.toLowerCase() === 'all') {

                // If we don't return it this way, the empty values will not be displayed
                if (value) {
                    return value
                }

                return true

            }

            // If this filter has no value we just skip the entire filter.
            if ( ! self.$props.params.connectedUsersStatusFilterValue) {
                return true
            }

            if (value) {
                // partially contains the searched word.
                return value.toLowerCase().includes(self.$props.params.connectedUsersStatusFilterValue.toLowerCase())
            }

            return value
        },
        removeDoubleQuotes (string) {
            return string?.replaceAll('"', '')
        },
        connectedUsersGeneralFilter (value) {

            let self = this

            // If this filter has no value we just skip the entire filter.
            if ( ! self.$props.params.connectedUsersIpFilterValue) {
                return true
            }

            if (value) {
                // partially contains the searched word.
                return value.toLowerCase().includes(self.$props.params.connectedUsersIpFilterValue.toLowerCase())
            }

            return value

        },

        connectedUsersMacFilter (value) {

            let self = this

            // If this filter has no value we just skip the entire filter.
            if ( ! self.$props.params.connectedUsersMacFilterValue) {
                return true
            }

            if (value) {
                // partially contains the searched word.
                return value.toLowerCase().includes(self.$props.params.connectedUsersMacFilterValue.toLowerCase())
            }

            return value

        },

        async openInformationConnectedUsersAddEquipmentDialog (mac) {

            let self = this

            try {

                const response = await this.vuelidateIsUniqueForTwoLevelNestedCustomColumn(mac, this.users, 'devices', 'mac')

                if ( ! response) {

                    self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! It appears we already have this mac address in use'), 'error')

                } else {

                    self.informationConnectedUsersAddEquipmentDialog = true
                    self.informationConnectedUsersAddEquipmentParams = {
                        informationConnectedUsersAddEquipmentDialog: true,
                        mac
                    }

                }

            } catch (e) {
                self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! something went wrong and we could not open the add equipment dialog. Please try again in sometime'), 'error')
                // FIXME: REMOVE THIS
                console.log(e)
            }

        }

    }

}

</script>
